import { Component } from '@angular/core';
import { ReportGetter } from '@app/main/report/directives/ReportGetter';
import { ReportBuilderService } from '@app/main/report/services/report-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationService } from '@shared/services/navigation.service';
import { GuardService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-report-header',
    templateUrl: './report-header.component.html',
    styleUrls: ['./report-header.component.scss'],
    standalone: false
})
export class ReportHeaderComponent extends ReportGetter {
    constructor(
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }
}
